module.exports = __webpack_public_path__ + "img/t1-endorsement-list.79e3773b.png";